













import { defineComponent, computed, watch } from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';

import KnowledgeQuery from '@/gql/getKnowledges.gql';

const CommonKnowledgeSelector = defineComponent({
  setup(props: any, context: any) {
    /* ==== Define creator group ==== */
    const { result, loading } = useQuery(KnowledgeQuery);
    const item = useResult(result, { data: [] }, (data) => data.knowledges);
    const itemName = computed(() => {
      const temp: string[] = [];
      item.value.data.forEach((element: any) => {
        temp.push(element.name);
      });
      return temp;
    });
    const itemId = computed(() => {
      const temp: string[] = [];
      item.value.data.forEach((element: any) => {
        temp.push(element.id);
      });
      return temp;
    });
    // ============================== //

    const _value = computed(() => props.value);

    return {
      itemId,
      itemName,
      loading,
      _value,
    };
  },
  props: {
    label: {
      type: String,
      default() { return 'องค์ความรู้'; },
    },
    value: {
      type: String,
      default() { return ''; },
    },
    displayCode: {
      type: Boolean,
      default() { return false; },
    },
  },
});

export default CommonKnowledgeSelector;
